<template>
  <base-modal :box="box_init" :step="step">
    <template slot="description">
      <div>
        {{$t('pbx.worksheet.action.call.state.init.description')}}
        <router-link :to="{ name: 'pbx.service-package.index' }">
          <span @click='$refs.close.$el.click()'> {{ $t('pbx.breadcrumb.title') }} </span>
        </router-link> -
        <router-link :to="{ name: 'pbx.operator.index' }">
          <span @click='$refs.close.$el.click()'> {{ $t('pbx.breadcrumb.operator.index') }} </span>
        </router-link > -
        <router-link :to="{ name: 'pbx.contact.index' }">
          <span @click='$refs.close.$el.click()'> {{ $t('pbx.breadcrumb.contact.index') }} </span>
        </router-link>
      </div>
    </template>
    <z-form ref="form" @submit.native.prevent="save">
      <form-input-name v-model="form.name" :box_type="box.type" />

      <z-form-group class="row">
        <div class="col-4 text-right">
          {{ $t('pbx.worksheet.action.call.input.timeout.label') }}
        </div>
        <z-form-input :rules="{ required: true }" class="col-8">
          <timeout-select v-model="form.params.timeout" class="w-50" />
        </z-form-input>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-4 text-right">
          {{ $t('pbx.worksheet.action.call.input.contact.label') }}
        </div>
        <z-form-input :rules="{ required: true }" class="col-8">
          <contact-select v-model="form.params.contact_method" />
        </z-form-input>
      </z-form-group>
    </z-form>
    <i-button 
      slot="footer-cancel"
      slot-scope="{ close }"
      size="large"
      @click="close()"
      ref='close'
    >
      {{ $t('pbx.worksheet.modal.action.main.button.cancel') }}
    </i-button>
    <i-button
      slot="footer-ok"
      slot-scope="{ is_button_loading }"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('pbx.worksheet.modal.action.main.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import FormInputName from '../../../_base/_fragments/form-input-name';
  import TimeoutSelect from '@pbx/components/worksheets/action-types/_fragments/select-timeout';
  import ContactSelect from '@pbx/components/worksheets/action-types/_fragments/select-contact';
  import { StepMixin } from '../../../_base/step-mixin';

  /**
   * props.box - автоматически прокидывается в form
   * чтобы сохранить состояние шага, используй mixin_save_step из StepMixin
   */

  export default {
    components: { BaseModal, FormInputName, TimeoutSelect, ContactSelect },
    mixins: [StepMixin],

    methods: {
      save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            const box = this.mixin_get_box(this.form);
            this.$emit('on-save', box);
          }
        });
      }
    }
  };
</script>
